<div
    class="loading-overlay srm-loading-overlay"
    [ngClass]="{ 'loading-overlay-playbreak': apiVanillaService.persistPlaybreak || isOverlayPlayBreakAdjusted }"
    data-crlat="loading-overlay"
    scroll-fix></div>
